import * as mhReact from "mhreact";
import App from "./app/app.jsx";
var root = mhReact.createRoot(document.getElementById("root"));
root.render(mhReact.createElement(App, null));